import axiosInstance from '../auth/FetchInterceptor'
import { API_URL } from '../constants/environment'
import { PartialProductItem } from '../store/basket/types'

// TODO api typings
type GenerateOrderNameResponse = {
  name: string;
}

type ExternalSourceProposalRequest = {
  name: string;
  message: string;
  client: string;
  urls: string[];
}
type ExternalSourceProposalResponse = {
  success: boolean;
}

type ProposalServiceType = {
  post: (proposalhData: AnyType) => Promise<AnyType>;
  getProposalData: (proposalRequestData: AnyType) => Promise<AnyType>;
  generateOrderName: (partialProductItems: PartialProductItem[]) => Promise<GenerateOrderNameResponse>;
  addProposalFromExternalSource: (request: ExternalSourceProposalRequest) => Promise<ExternalSourceProposalResponse>;
};

const ProposalService: ProposalServiceType = {
  post: proposalhData =>
    axiosInstance({
      url: `${API_URL.PROPOSALS}/proposal`,
      method: 'post',
      data: proposalhData,
    }),
  getProposalData: proposalRequestData =>
    axiosInstance({
      url: `${API_URL.PROPOSALS}/get`,
      method: 'get',
      data: proposalRequestData,
    }),
  generateOrderName: partialProductItems =>
    axiosInstance.post<never, GenerateOrderNameResponse>(
      `${API_URL.PROPOSALS}/generate-order-name`,
      {
        items: partialProductItems,
      },
    ),
  addProposalFromExternalSource: (request: ExternalSourceProposalRequest) =>
    axiosInstance
      .post<never, ExternalSourceProposalResponse, ExternalSourceProposalRequest>(
        `${API_URL.CUSTOMER_AREA}/punchout-catalogs`,
        request,
      ),
}

export default ProposalService
